export const worksheets = {
  actions: {
    start: 'Autoinformator',
    media: 'Pesan audio',
    postback: 'Postback',
    menu: 'IVR'
  }
};
